import React, { createContext, useEffect, useState } from "react";

const TimerContext = createContext();

export const TimerProvider = ({ initialTime, onTimeUp, children }) => {
  const [time, setTime] = useState(initialTime * 60);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  useEffect(() => {
    if (time <= 0) {
      onTimeUp(time, formatTime);
      return;
    }

    const timerId = setInterval(() => {
      setTime((prevTime) => {
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [time, onTimeUp]);

  return (
    <TimerContext.Provider value={{ time, setTime, formatTime }}>
      {children}
    </TimerContext.Provider>
  );
};

export {TimerContext}